<template>
  <!-- dialog forgot password -->
<v-dialog v-model="data.dialog.forgotpassword.visible" width="auto" height="auto">
    <div style="width:100%">
    <v-btn
        size="x-small"
        class="float-right ma-3"
        icon="mdi-close"
        @click="data.dialog.forgotpassword.visible=false"
      ></v-btn>
    </div>
    <v-alert	
      border="start"
      density="compact"
      text="Hubungi Admin atau Supervisor Divisi Anda untuk reset password."
      type="info"
    ></v-alert>
</v-dialog> 

  <v-form @submit.prevent="doLogin" id="form-login">
    <div>
      <v-card
        class="mx-auto my-auto pa-5 pb-3 pt-3"
        elevation="1"
        max-width="368"
        rounded="lg"
      >
        <v-img class="mx-auto my-6" max-width="142" :src="data.logo"></v-img>
        <div class="text-center text-login font-weight-bold my-2">Masuk</div>
        <div class="text-center text-login-subtitle text-medium-emphasis my-2">
          Masuk ke akun Insting Anda
        </div>

        <v-divider v-if="data.error.message != null" class="my-5"></v-divider>
        <v-alert
          id="form-alert-message"
          v-if="data.error.message != null"
          color="error"
          icon="$error"
          variant="tonal"
          :text="data.error.message"
        ></v-alert>
        <v-divider class="my-5"></v-divider>

        <div class="text-subtitle-1 font-weight-bold my-2">Nomor iSafe</div>

        <v-text-field
          id="form-input-isafe"
          v-model="data.isafeNo"
          density="compact"
          placeholder="Masukkan Nomor iSafe Anda"
          variant="outlined"
        ></v-text-field>

        <div
          class="text-subtitle-1 font-weight-bold d-flex align-center justify-space-between my-2"
        >
          Kata Sandi
        </div>

        <v-text-field
          id="form-input-password"
          v-model="data.password"
          :append-inner-icon="data.visible ? 'mdi-eye-off' : 'mdi-eye'"
          :type="data.visible ? 'text' : 'password'"
          density="compact"
          placeholder="Masukkan Kata Sandi Akun Anda"
          variant="outlined"
          @click:append-inner="data.visible = !data.visible"
        ></v-text-field>

        <v-checkbox
          id="form-input-remember"
          color="#EF4444"
          v-model="data.isRemember"
          label="Ingat Saya"
        ></v-checkbox>

        <v-btn
          id="form-btn-login"
          @click="doLogin(false)"
          rounded="lg"
          block
          class="mb-3 text-none btn-gradient-red"
          color="blue"
          size="large"
          variant="flat"
        >
          Masuk dengan iSafe
        </v-btn>

        <v-btn
          id="form-btn-forgot-password"
          rounded="lg"
          block
          class="mb-3 text-none font-weight-bold"
          color="red-darken-3"
          size="large"
          variant="text"
          @click="data.dialog.forgotpassword.visible=true;logAnalyticsEvent(data.analytics, ANALYTICS_EVENTS.LOGIN_RESET_CLICK_BUTTON);"
        >
          Lupa Kata Sandi?
        </v-btn>

        <v-divider class="mb-6"></v-divider>

        <v-btn
          id="form-btn-login-google"
          @click="doLoginWithGoogle"
          rounded="lg"
          block
          class="mb-8 text-none"
          color="black"
          size="large"
          variant="outlined"
        >
          Masuk dengan Google
        </v-btn>
        <div class="text-center text-login-subtitle text-medium-emphasis my-2">
          Alfa.0.0.6
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script setup>
import { layoutStore } from "@/stores/layout";
import { onMounted, reactive, inject, getCurrentInstance } from "vue";
import util from "@/assets/js/util";
import insting from "@/assets/js/insting";
import { useRouter } from "vue-router";
import { authStore } from "@/stores/auth";
import Logo from "@/assets/logo.png";
import { initKeycloak, getKeycloak} from "../../config/keycloak.js";
import search from "@/assets/js/search";
import {
  logAnalyticsEvent,
  ANALYTICS_EVENTS,
} from "@/helpers/AnalyticsHelper.js";
// import qs from 'qs'
// import { Switch } from "@headlessui/vue";

// layoutStore().change("clear");

const data = reactive({
  analytics:null,
  dialog:{
    forgotpassword:{
      visible:false,
    },
  },
  error: {
    message: null,
  },
  isafeNo: "",
  password: "",
  isRemember: false,
  logo: Logo,
  visible: false,
  keycloak: null,
  AccessToken: "",
});
const axios = inject("axios");
const axiosInsting = inject("axiosInsting");
const router = useRouter();
const auth = authStore();
const layout = layoutStore();

async function doLogin(isLoginWithGoole) {
  // login esb
  var result = {};
  var resultTokenInsting = {};
  var resultDataInsting = {};
  // login insting & get me

  if (isLoginWithGoole) {
    logAnalyticsEvent(data.analytics, ANALYTICS_EVENTS.LOGIN_IAM_CLICK_BUTTON);
    resultTokenInsting = await doInstingLoginWithGoole();
  } else {
    logAnalyticsEvent(data.analytics, ANALYTICS_EVENTS.LOGIN_CLICK_BUTTON);
    resultTokenInsting = await doLoginInsting();
  }
  if (resultTokenInsting) {
    result.appTokenInsting = resultTokenInsting.data.token;
    result.profile = resultTokenInsting.data.profile;
    result.profile.instingID = resultTokenInsting.data.profile.id; //"ffd18648-7889-40e3-804e-e7b6ddd5df82";
    result.token = resultTokenInsting.data.token;
    result.tokenEsb = resultTokenInsting.data.token_esb;

    auth.updateJwtInsting(result);
  } else {
    return;
  }
  resultDataInsting = await doGetMeInsting();
  if (resultDataInsting) {
    localStorage.setItem("dataInsting", JSON.stringify(resultDataInsting.data));
  } else {
    return;
  }

  result.rememberMe = data.isRemember;
  result.config = await search.getConfig(axiosInsting);
  auth.setLoginType("main");

  result.profile.photo = await insting.getImage(resultDataInsting.data.info.isafe_type,axiosInsting,result.profile.isafe_no, result.profile.id)
  // result.profile.photo = await insting.getImage(resultDataInsting.data.info.isafe_type,axiosInsting,"", result.profile.id)
  // result.profile.photo = await insting.getImage("non-isafe",axiosInsting,result.profile.isafe_no, "1f6df13b-e41e-4f75-b5d1-d90f1fe8fac7")
  result.profile.isafe_type = resultDataInsting.data.info.isafe_type;

  auth.updateJwt(result);

  localStorage.setItem("config", JSON.stringify(result.config));
  layout.setMenus(resultDataInsting.data.menus);

  await search.getHistory(axiosInsting);
  await router.push({ path: "/reportvalidation" });
}

async function doLoginInsting() {
  var result = {};
  result = await axiosInsting
    .post("auth/token", {
      username: data.isafeNo,
      password: data.password,
      rememberMe: data.isRemember,
    })
    .then(
      (r) => {
        return r.data;
      },
      (e) => {
        data.error.message = util.getErrorMessage(e);
      }
    );
  return result;
}

async function doInstingLoginWithGoole() {
  var result = {};
  result = await axiosInsting
    .post("auth/ugems", {
      ugemsAccessToken: data.keycloak.token,
      ugmesRefreshToken: data.keycloak.refreshToken,
      rememberMe: data.keycloak.tokenParsed,
    })
    .then(
      (r) => {
        return r.data;
      },
      (e) => {
        data.error.message = util.getErrorMessage(e);
      }
    );

  return result;
}

async function doGetMeInsting() {
  var result = {};
  result = await axiosInsting.get("auth/me").then(
    (r) => {
      return r.data;
    },
    (e) => {
      data.error.message = util.getErrorMessage(e);
    }
  );
  return result;
}

async function doLoginWithGoogle() {
  data.AccessToken = "Authenticating...."; // Value sementara AccessToken yang menandakan bahwa script sedang berjalan

  const keycloak = getKeycloak(); // Fetch the existing Keycloak instance

  if (!keycloak) {
    console.error("Keycloak instance not found");
    return;
  }

  keycloak
    .init({ onLoad: "login-required" })
    .then(async (auth) => {
      // menjalankan script keycloack dengan membawa parameter onload dengan value login-required
      if (!auth) {
        console.log("NOT Authenticated");
        data.AccessToken = ""; // jika autentikasi gagal makan value AccessToken di kosongkan
      } else {
        console.log("Authenticated");
        data.AccessToken = data.keycloak.token; // jika autentikasi berhasil maka mengisi variable AccessToken dengan token dari keycloack
      }
      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_KEYCLOAK_URL}/realms/ugems/broker/google/token`, // jika login menggunakan google
          {
            headers: {
              Authorization: `Bearer ${data.keycloak.token}`, // membawa headers dengan token keycloack
            },
          }
        );
      } catch (err) {
        console.log("failed to get google token");
      }

      // TODO REMOVE CONSOLE LOG
      localStorage.setItem("ugems-accessToken", data.keycloak.token); // menyimpan data token di local storage
      localStorage.setItem("ugems-refreshToken", data.keycloak.refreshToken);
      localStorage.setItem(
        "ugems-tokenParsed",
        JSON.stringify(data.keycloak.tokenParsed)
      );

      await doLogin(true);
    })
    .catch((err) => {
      data.error.message = util.getErrorMessage(err);
    });
}

onMounted(() => {
  const instance = getCurrentInstance();
  data.analytics = instance?.appContext.config.globalProperties.$analytics;
  if (!data.analytics) {
    console.error('$analytics is undefined');
  }

  // util.clearCookies();
  
  data.error.message = null; 
  
  if (!getKeycloak()) {
    data.keycloak = initKeycloak(); 
  }

  const hash = window.location.hash;
  if (hash.includes("state=") && hash.includes("code=")) {
    console.log("From Redirect URL");
    doLoginWithGoogle();
  }
});
</script>

<style scoped>
.text-login {
  font-size: 20px;
}
.text-login-subtitle {
  font-size: 13px;
}
</style>
